// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3FVMp","noInteraction":"EventWrapper_noInteraction__joZeE"};